import React from "react";
import { useHistory } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

const SectionHeader = ({ path, title, handleClose }) => {
  const history = useHistory();

  const handleCloseButton = () => {
    history.goBack();
  };

  return (
    <div className="lg:px-32 px-8 md:pt-6 py-4 bg-white shadow-lg">
      {/* Back Button */}
      <div className="block lg:-mx-24">
        <button className="outline-none" onClick={handleCloseButton}>
          <div className="flex space-x-4 items-center">
            <MdArrowBack size={24} />
            <span className="md:text-base text-sm font-bold tracking-widest uppercase">
              Back
            </span>
          </div>
        </button>
      </div>
      {/* Title */}
      <div className="block md:mt-4 mt-2">
        <h1 className="font-bold md:text-3xl text-xl">{title}</h1>
      </div>
    </div>
  );
};

export default SectionHeader;
